var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.917 4.625c-.22.165-.47.472-.67 1.069-.186.56-1.168 3.414-2.395 6.973h8.296a1683.88 1683.88 0 0 1-2.396-6.973c-.199-.597-.448-.904-.669-1.07-.212-.159-.536-.29-1.083-.29-.547 0-.87.131-1.083.29zm-12.25 8.042h5.66c1.397-4.052 2.559-7.427 2.759-8.027.356-1.07.94-2.014 1.83-2.682C13.817 1.285 14.88 1 16 1c1.12 0 2.185.285 3.083.958.891.668 1.475 1.612 1.832 2.682.2.6 1.362 3.975 2.76 8.027h5.658a1.667 1.667 0 0 1 0 3.333H2.666a1.667 1.667 0 1 1 0-3.333zm0 6.666a1.667 1.667 0 1 0 0 3.333h2.207l-.892 2.581-.888 2.572-.335.968a1.667 1.667 0 1 0 3.15 1.09l.334-.97.889-2.572 1.267-3.67h15.2l1.267 3.67.89 2.571.334.97a1.667 1.667 0 1 0 3.152-1.089l-.335-.97-.89-2.57-.89-2.582h2.206a1.667 1.667 0 0 0 0-3.333H2.666zm25 10 1.575-.545-1.575.545zm0 0-1.576.544 1.577-.544zm-23.333 0 1.575.544-1.576-.544zm0 0-1.575-.545 1.574.545z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmp);
export default __webpack_public_path__ + "static/media/AMP.471722fa5cc441aceb129f449a17d5f4.svg";
export { ForwardRef as ReactComponent };